export default "__VITE_ASSET__ec53a459__"